import React from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

interface FAQItemProps {
  question: string;
  answer: string | string[] | React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

export const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer,
  isOpen,
  onToggle,
}) => {
  const renderAnswer = () => {
    if (Array.isArray(answer)) {
      return (
        <div className="space-y-2">
          {answer.map((step, index) => (
            <p
              key={index}
              className="text-base leading-relaxed text-neutral-900"
            >
              {step}
            </p>
          ))}
        </div>
      );
    }

    if (typeof answer === "string") {
      return (
        <p className="text-base leading-relaxed text-neutral-900">{answer}</p>
      );
    }

    return (
      <div className="text-base leading-relaxed text-neutral-900">{answer}</div>
    );
  };

  return (
    <div className="border-neutral border-b">
      <button
        className="focus-visible:ring-violet flex w-full items-center justify-between px-0 py-3 text-left hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="text-indigo font-sans text-base font-medium">
          {question}
        </span>
        {isOpen ? (
          <ChevronUpIcon className="text-indigo mr-6 size-6 flex-shrink-0" />
        ) : (
          <ChevronDownIcon className="text-indigo mr-6 size-6 flex-shrink-0" />
        )}
      </button>
      {isOpen && <div className="px-0 pb-3">{renderAnswer()}</div>}
    </div>
  );
};
